import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ZapCircle = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "zap-circle",
    className: clsx('stroke-current', className)
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m12 5.5-4.6384 6.7468c-.2792.4061-.4188.6092-.4105.778a.5001.5001 0 0 0 .196.3727c.1344.1025.3808.1025.8737.1025H12v5l4.6384-6.7468c.2792-.4061.4189-.6092.4105-.778a.4999.4999 0 0 0-.1961-.3727c-.1343-.1025-.3807-.1025-.8736-.1025H12v-5Z"
    }), /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 22c5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10C6.4771 2 2 6.4771 2 12c0 5.5228 4.4771 10 10 10Z"
    })]
  }));
};
export default ZapCircle;